import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  multiSelect: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.secondary,
  },
  link: {
    paddingLeft: theme.spacing(2),
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  infoIcon: {
    cursor: 'help',
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(0.5),
  },
}))

export default styles
